/**本地存储枚举*/
enum LocalEnum {
    /**登录信息*/
    TOKEN_OBJ = "tokenObj",
    /**语言信息*/
    LANG = "lang",
}
export default LocalEnum;
